export default {
  title: 'Punten & kortingen',
  store_credit: 'Winkelkrediet',
  points_balance: 'Puntensaldo',
};
